(function() {
  if (!document.body) return;

  function refreshSplides() {
    window.dispatchEvent(new Event('resize'));
    document.querySelectorAll('.section-related-products *, .section-recently-viewed-products *').forEach(function(el) {
      if (el.slideInstance && typeof el.slideInstance.refresh === 'function') {
        try { el.slideInstance.refresh(); } catch(e) {}
      }
    });
    var rv = document.querySelector('recently-viewed-products');
    if (rv) rv.querySelectorAll('*').forEach(function(el) {
      if (el.slideInstance && typeof el.slideInstance.refresh === 'function') {
        try { el.slideInstance.refresh(); } catch(e) {}
      }
    });
  }

  function init() {
    var relatedInner = document.querySelector('.section-related-products');
    var recentEl = document.querySelector('recently-viewed-products');
    if (!relatedInner || !recentEl) return;

    var relatedSection = relatedInner.closest('.shopify-section') || relatedInner;
    var recentSection = recentEl.closest('.shopify-section') || recentEl;
    if (relatedSection.dataset.jbTabbed) return;
    relatedSection.dataset.jbTabbed = '1';

    function grabLabel(scope) {
      var h = scope.querySelector('.section-header, .related-products-header, .header-recently-viewed-products');
      var label = null;
      if (h) {
        var t = h.querySelector('h2, h3, .h2, .h3, [class*="heading"]');
        if (t && t.textContent.trim()) label = t.textContent.trim();
        h.style.display = 'none';
      }
      return label;
    }

    var nav = document.createElement('div');
    nav.className = 'jb-ptabs-nav container flex gap-x-10';

    var tabs = [
      { label: 'You may also like', section: relatedSection },
      { label: 'Recently viewed', section: recentSection }
    ];

    tabs.forEach(function(t, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = t.label;
      btn.className = 'jb-ptabs-btn' + (i === 0 ? ' active' : '');
      btn.style.cssText = 'background:none;border:none;cursor:pointer;padding:0 0 4px;color:currentColor;letter-spacing:0.04em;';
      btn.addEventListener('click', function() {
        nav.querySelectorAll('.jb-ptabs-btn').forEach(function(b) {
          b.classList.remove('active');
          b.style.opacity = '0.45';
          b.style.borderBottom = 'none';
        });
        btn.classList.add('active');
        btn.style.opacity = '1';
        btn.style.borderBottom = '1px solid currentColor';
        tabs.forEach(function(x) {
          x.section.classList.toggle('jb-tab-hidden', x !== t);
        });
        requestAnimationFrame(refreshSplides);
        setTimeout(refreshSplides, 100);
      });
      btn.style.opacity = i === 0 ? '1' : '0.45';
      btn.style.borderBottom = i === 0 ? '1px solid currentColor' : 'none';
      nav.appendChild(btn);
    });

    relatedSection.parentNode.insertBefore(nav, relatedSection);
    recentSection.classList.add('jb-tab-hidden');

    var n = 0;
    var fixer = setInterval(function() {
      n++;
      refreshSplides();
      if (n > 12) clearInterval(fixer);
    }, 500);

    var attempts = 0;
    var poll = setInterval(function() {
      attempts++;
      var l1 = grabLabel(relatedSection);
      var l2 = grabLabel(recentSection);
      var btns = nav.querySelectorAll('.jb-ptabs-btn');
      if (l1) btns[0].textContent = l1;
      if (l2) btns[1].textContent = l2;
      if ((l1 && l2) || attempts > 20) clearInterval(poll);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  var tries = 0;
  var t = setInterval(function() {
    tries++;
    init();
    if (document.querySelector('.shopify-section[data-jb-tabbed]') || tries > 10) clearInterval(t);
  }, 600);
})();
